const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"98829a4ae8b51ee1a98fc816963333f889953679"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["zcm-site@zentrum-fur-cannabismedizin"]={id:"98829a4ae8b51ee1a98fc816963333f889953679"};
      